import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { useFilterFamilyOptions } from '../../../hooks/useFilterFamilyOptions';
import { useFilterFamilySelect } from '../../../hooks/useFilterFamilySelect';
import GroupOption from './general/GroupOption';
import DataExplorerEmptyState from './general/DataExplorerEmptyState';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const FilterFamilyGroupSelectOptions = ({
  searchString,
  category
}) => {
  const {
    filterFamilyOptions
  } = useFilterFamilyOptions(searchString);
  const {
    disabledFilterFamilies,
    onFilterFamilySelect
  } = useFilterFamilySelect();
  const optionGroups = filterFamilyOptions.filter(optionGroup => optionGroup.category === category);
  if (optionGroups.length === 0) {
    return /*#__PURE__*/_jsx(DataExplorerEmptyState, {
      message: "customerDataFiltersUI.dataExplorer.emptyState.noOptions"
    });
  }
  const hasMultipleGroups = optionGroups.length > 1;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: optionGroups.map((optionsGroup, index) => {
      return /*#__PURE__*/_jsxs("div", {
        children: [hasMultipleGroups && /*#__PURE__*/_jsx("b", {
          children: /*#__PURE__*/_jsx(TruncateString, {
            useFlex: true,
            paddingInlineStart: "400",
            children: optionsGroup.text
          })
        }), optionsGroup.options.map((option, childIndex) => /*#__PURE__*/_jsx(GroupOption, {
          categoryLabel: option.text,
          dataSeleniumInfo: option.value,
          dataSeleniumTest: "fr-filter-family-option",
          disabled: disabledFilterFamilies[option.value],
          hideRightIcon: false,
          onClick: () => {
            void (async () => {
              try {
                await onFilterFamilySelect(option);
              } catch (e) {
                console.error('Error selecting filter family group option:', e);
              }
            })();
          },
          indent: hasMultipleGroups
        }, `${childIndex}-${option.text}`))]
      }, `${index}-${optionsGroup.text}`);
    })
  });
};
export default FilterFamilyGroupSelectOptions;